import { render, staticRenderFns } from "./redeem-voucher.vue?vue&type=template&id=72dc3ada&scoped=true&"
import script from "./redeem-voucher.vue?vue&type=script&lang=ts&"
export * from "./redeem-voucher.vue?vue&type=script&lang=ts&"
import style0 from "./redeem-voucher.vue?vue&type=style&index=0&id=72dc3ada&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dc3ada",
  null
  
)

export default component.exports